// =================================================================
// FINANCIAMIENTO SIMPLIFICADO - Diseño 2 Cajas
// =================================================================

// ========== DROPDOWN FUNCTIONALITY ==========
function toggleFinanciamiento() {
  const dropdown = document.getElementById('financiamiento-dropdown');
  dropdown.classList.toggle('open');
}

function initializeDropdownState() {
  const dropdown = document.getElementById('financiamiento-dropdown');
  if (!dropdown) return;
  
  const isMobile = window.innerWidth <= 768;
  
  // Desktop: open by default, Mobile: closed by default
  if (!isMobile) {
    dropdown.classList.add('open');
  } else {
    dropdown.classList.remove('open');
  }
}

function handleResize() {
  const dropdown = document.getElementById('financiamiento-dropdown');
  if (!dropdown) return;
  
  const isMobile = window.innerWidth <= 768;
  const wasMobile = dropdown.hasAttribute('data-was-mobile') ? 
    dropdown.getAttribute('data-was-mobile') === 'true' : null;
  
  // Only reset if we're crossing the mobile/desktop boundary
  if (wasMobile !== null && wasMobile !== isMobile) {
    initializeDropdownState();
  }
  
  dropdown.setAttribute('data-was-mobile', isMobile.toString());
}

// ========== ESTADO PERSISTENTE ENTRE PRODUCTOS ENTRELAZADOS ==========
// Como aquí no hay variantes sino productos entrelazados, cada cambio de
// producto re-ejecuta initFinancingCalculator(). Guardamos a nivel de modulo
// el banco que el cliente tenia activo para poder restaurarlo tras el re-init.
// - selectedBankKey: valor de data-banco (ej. "bbva", "interbank", "diners")
// - selectedMonths:  meses elegidos en el selector (se intenta preservar si el
//                    nuevo banco tambien ofrece ese plazo)
let selectedBankKey = null;
let selectedMonths = null;

// ========== CALCULADORA DE FINANCIAMIENTO ==========
// Initialize on page load
document.addEventListener('DOMContentLoaded', initFinancingCalculator);
window.addEventListener('load', initFinancingCalculator);

// Track URL changes for SPA-style navigation
// SCOPE: observar SOLO el contenedor del producto principal, NO todo el
// document. El carrusel de recomendaciones (variant-recommendations-carousel)
// inserta y clona decenas de nodos vía slick; si observamos todo el document,
// esas mutaciones disparan el observer constantemente. Acotar a product-info
// evita ese ruido y solo reaccionamos a cambios reales del PDP.
let currentUrl = location.href;
const urlObserver = new MutationObserver(() => {
  if (location.href !== currentUrl) {
    currentUrl = location.href;
    setTimeout(initFinancingCalculator, 300);
  }
});

// Start observing URL changes (scoped al contenedor del producto principal).
(function startUrlObserver() {
  const scope = document.querySelector('product-info.product__info-container') || document.body || document;
  urlObserver.observe(scope, { subtree: true, childList: true });
})();

function initFinancingCalculator() {
  // Initialize dropdown first
  initializeDropdownState();
  
  // Handle window resize for dropdown
  window.removeEventListener('resize', handleResize);
  window.addEventListener('resize', handleResize);
  
  // Cache DOM elements
  const selector = document.getElementById('selector-cuotas');
  const resultElement = document.getElementById('resultado-cuota');
  const bankLogosContainer = document.getElementById('banco-logos');
  
  // Skip if needed elements aren't present
  if (!selector || !resultElement || !bankLogosContainer) return;
  
  const bankLogos = Array.from(bankLogosContainer.querySelectorAll('.logo-banco'));
  const bankInfoSections = document.querySelectorAll('.info-banco');
  
  // State variables
  let lastPrice = getCurrentPrice();
  let lastMonths = selector.value || '';
  
  // Format money with appropriate currency symbol (S/)
  function formatMoney(amount) {
    const hasDecimals = amount % 1 !== 0;
    const formattedNumber = hasDecimals 
      ? amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : Math.trunc(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'S/ ' + formattedNumber;
  }

  // Devuelve el maximo de cuotas que ofrece un logo de banco (0 si no tiene).
  function getMaxMonths(bankLogo) {
    if (!bankLogo?.dataset?.meses) return 0;
    const months = bankLogo.dataset.meses.split(',')
      .map(m => parseInt(m.trim()))
      .filter(m => !isNaN(m));
    return months.length ? Math.max(...months) : 0;
  }
  
  // Update the installment options based on selected bank.
  // preferMonths: si se pasa y el banco ofrece ese plazo, se preselecciona;
  // de lo contrario cae al maximo disponible (comportamiento por defecto).
  function populateInstallmentOptions(bankLogo, preferMonths) {
    if (!bankLogo?.dataset?.meses) return;
    
    const months = bankLogo.dataset.meses.split(',')
      .map(m => parseInt(m.trim()))
      .filter(m => !isNaN(m))
      .sort((a, b) => a - b);
      
    const maxInstallments = Math.max(...months);

    // Determinar que plazo dejar seleccionado: el preferido si existe en este
    // banco, si no el maximo.
    let monthToSelect = maxInstallments;
    if (preferMonths != null && months.includes(parseInt(preferMonths))) {
      monthToSelect = parseInt(preferMonths);
    }
    
    // Clear and add new options
    selector.innerHTML = '';
    months.forEach(month => {
      const option = document.createElement('option');
      option.value = month;
      option.textContent = `${month} meses`;
      if (month === monthToSelect) option.selected = true;
      selector.appendChild(option);
    });

    // Recordar el plazo elegido a nivel de modulo.
    selectedMonths = monthToSelect;
    
    // Update calculation
    updateInstallmentAmount();
  }

  // Calculate and display installment amount
  function updateInstallmentAmount() {
    const currentPrice = getCurrentPrice();
    const currentMonths = parseInt(selector.value) || 1;
    
    if (currentPrice !== lastPrice || currentMonths !== lastMonths) {
      const installmentAmount = currentPrice / currentMonths;
      resultElement.textContent = formatMoney(installmentAmount);
      lastPrice = currentPrice;
      lastMonths = currentMonths;
    }

    // Mantener sincronizado el estado de modulo con lo que ve el usuario.
    selectedMonths = currentMonths;
    
    // Update Powerpay price (always 3 months)
    const powerpayElement = document.getElementById('powerpay-resultado');
    if (powerpayElement) {
      const powerpayAmount = currentPrice / 3;
      powerpayElement.textContent = formatMoney(powerpayAmount);
    }
  }

  // Activate a bank logo.
  // preferMonths: plazo a preservar al repoblar el selector (opcional).
  function activateBank(bankLogo, preferMonths) {
    // Reset all logos
    bankLogos.forEach(logo => logo.classList.remove('active'));
    bankInfoSections.forEach(section => section.classList.remove('active'));
    
    // Activate selected logo
    bankLogo.classList.add('active');
    
    // Activate corresponding info section
    const bankInfoId = `${bankLogo.dataset.banco}-info`;
    const bankInfo = document.getElementById(bankInfoId);
    if (bankInfo) bankInfo.classList.add('active');

    // Recordar el banco activo a nivel de modulo.
    selectedBankKey = bankLogo.dataset.banco || null;

    // Update options for this bank
    populateInstallmentOptions(bankLogo, preferMonths);
  }

  // ========== SELECCION INICIAL ==========
  if (bankLogos.length > 0) {
    // 1) Intentar restaurar el banco que el cliente tenia activo (productos
    //    entrelazados: se conserva la eleccion previa).
    let targetBank = null;
    if (selectedBankKey) {
      targetBank = bankLogos.find(l => l.dataset.banco === selectedBankKey) || null;
    }

    // 2) Si no hay banco previo (primera apertura de la PDP), elegir el banco
    //    que ofrece MAS cuotas, no siempre BBVA.
    if (!targetBank) {
      targetBank = bankLogos.reduce((best, logo) =>
        getMaxMonths(logo) > getMaxMonths(best) ? logo : best
      , bankLogos[0]);
    }

    // Preservar el plazo previo solo si estamos restaurando un banco.
    activateBank(targetBank, selectedBankKey ? selectedMonths : null);
  }

  // Event Listeners
  selector.addEventListener('change', updateInstallmentAmount);

  // Bank logo clicks
  bankLogos.forEach((logo) => {
    logo.addEventListener('click', () => {
      // Click manual: activar banco y dejar su maximo por defecto.
      activateBank(logo, null);
    });
  });

  // ========== POWERPAY FUNCTIONALITY ==========
  const powerpayToggle = document.getElementById('powerpay-toggle');
  if (powerpayToggle) {
    // Remove existing listeners
    powerpayToggle.removeEventListener('click', handlePowerpayClick);
    powerpayToggle.addEventListener('click', handlePowerpayClick);
  }
}

// ========== POWERPAY MODAL FUNCTIONALITY ==========
function handlePowerpayClick(e) {
  e.preventDefault();
  openPowerpayModal();
}

function openPowerpayModal() {
  const modal = document.getElementById('powerpay-modal');
  const iframe = document.getElementById('powerpay-iframe');
  
  if (!modal || !iframe) return;
  
  // Get current price
  const currentPrice = getCurrentPrice();
  
  // Build PowerPay URL
  const powerpayUrl = `https://widget.powerpay.pe/?clientId=Y2tfN0hucDBtTDgxbkd5SWJqY1NVOVo3RFdMRS1MeVZxeC16dWNoZ2VuYUZjcw%3D%3D&price=${currentPrice}&theme=`;
  
  // Set iframe source
  iframe.src = powerpayUrl;
  
  // Show modal
  modal.classList.add('active');
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
}

function closePowerpayModal() {
  const modal = document.getElementById('powerpay-modal');
  const iframe = document.getElementById('powerpay-iframe');
  
  if (!modal) return;
  
  // Hide modal
  modal.classList.remove('active');
  
  // Clear iframe source
  if (iframe) {
    iframe.src = '';
  }
  
  // Restore body scroll
  document.body.style.overflow = '';
}

// Close modal when clicking outside
document.addEventListener('click', function(e) {
  const modal = document.getElementById('powerpay-modal');
  if (e.target === modal) {
    closePowerpayModal();
  }
});

// Close modal with ESC key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const modal = document.getElementById('powerpay-modal');
    if (modal && modal.classList.contains('active')) {
      closePowerpayModal();
    }
  }
});

// Get the current price using most reliable selectors
function getCurrentPrice() {
  // SCOPE: leer el precio SOLO dentro del contenedor del producto principal
  // (product-info.product__info-container). De lo contrario querySelector
  // devuelve el PRIMER .price-item--regular del documento, y al agregar el
  // carrusel de recomendaciones la pagina pasa a tener decenas de
  // .price-item--regular (uno por producto recomendado, por panel de variante).
  // Slick los clona/reordena, asi que el "primer" match podia ser el precio de
  // un accesorio barato del carrusel o un nodo a medio renderizar -> la cuota
  // se calculaba con un precio erroneo. Acotar al PDP lo evita.
  const scope = document.querySelector('product-info.product__info-container') || document;

  const selectors = [
    '.price__regular .price-item--regular',
    '.price-item--regular',
    '.actual_price_bold',
    '[data-product-price]',
    '.price__sale .price-item--sale',
    '.price__container .price'
  ];

  for (const selector of selectors) {
    const priceElement = scope.querySelector(selector);
    if (priceElement) {
      const priceText = priceElement.textContent || priceElement.getAttribute('data-product-price') || '0';
      const cleanPrice = priceText.replace(/[^\d.]/g, '');
      const price = parseFloat(cleanPrice);
      if (!isNaN(price) && price > 0) return price;
    }
  }

  return 0;
}

// Read more/less toggle function
function alternarLeerMas(infoId) {
  const infoSection = document.getElementById(infoId);
  if (!infoSection) return;
  
  const isExpanded = infoSection.classList.toggle('expandido');
  const button = infoSection.querySelector('.leer-mas');
  if (button) button.textContent = isExpanded ? 'Leer menos' : 'Leer más';
}

// ========== INTEGRATION WITH EXISTING FUNCTIONALITY ==========
// Make functions available globally for compatibility
window.initFinancingCalculator = initFinancingCalculator;
window.updateInstallmentAmount = function() {
  const selector = document.getElementById('selector-cuotas');
  const resultElement = document.getElementById('resultado-cuota');
  
  if (!selector || !resultElement) return;
  
  const currentPrice = getCurrentPrice();
  const currentMonths = parseInt(selector.value) || 1;
  const installmentAmount = currentPrice / currentMonths;

  // Mantener sincronizado el estado de modulo.
  selectedMonths = currentMonths;
  
  const hasDecimals = installmentAmount % 1 !== 0;
  const formattedNumber = hasDecimals 
    ? installmentAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : Math.trunc(installmentAmount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  resultElement.textContent = 'S/ ' + formattedNumber;
  
  // Update Powerpay price
  const powerpayElement = document.getElementById('powerpay-resultado');
  if (powerpayElement) {
    const powerpayAmount = currentPrice / 3;
    const hasDecimalsPP = powerpayAmount % 1 !== 0;
    const formattedNumberPP = hasDecimalsPP 
      ? powerpayAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : Math.trunc(powerpayAmount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    powerpayElement.textContent = 'S/ ' + formattedNumberPP;
  }
};

// ========== GLOBAL FUNCTIONS ==========
window.toggleFinanciamiento = toggleFinanciamiento;
window.alternarLeerMas = alternarLeerMas;
window.getCurrentPrice = getCurrentPrice;
window.openPowerpayModal = openPowerpayModal;
window.closePowerpayModal = closePowerpayModal;